import React from 'react';
import { Col, Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';

function RemoveProductItemComponent(props) {
  const {
    index,
    removeRow,
  } = props;

  return (
    <Col xs={ 6 } sm={ 6 } className="justify-content-end">
      <Button
        className={ "btn-icon-only rounded-circle index-" + index}
        color="warning"
        onClick={
          e => {
            e.preventDefault();
            removeRow(index);
          }
        }
      >
        <FontAwesomeIcon icon={ faMinusCircle }/>
      </Button>
    </Col>
  );
}

const RemoveProductItem = injectIntl(RemoveProductItemComponent)

export { RemoveProductItem, RemoveProductItemComponent }
